import { useEffect } from 'react';
import { useAuth } from '../context/AuthContext';

// The server-rendered planner is the canonical manager surface — the React
// manager routes are redundant and must not be reachable. Worker-role users
// get bounced to the worker app instead.
export const managerAreaTarget = (role) =>
  role === 'worker' ? '/worker' : '/map/planner';

const ManagerAreaRedirect = () => {
  const { user, effectiveRole } = useAuth();
  useEffect(() => {
    window.location.replace(managerAreaTarget(effectiveRole || user?.role || 'manager'));
  }, [user, effectiveRole]);
  return null; // renders nothing — children never mount
};

export default ManagerAreaRedirect;
